import React from "react";
import {
  Grid,
  Card,
  CardHeader,
  CardContent,
  Box,
  Typography,
  Paper,
} from "@mui/material";
import { Analytics as AnalyticsIcon } from "@mui/icons-material";
import { indigo, green, blue, orange, purple } from "@mui/material/colors";

const AdvancedSettings = ({ economyStatistics }) => {
  if (!economyStatistics) {
    return (
      <Box sx={{ p: 4, textAlign: "center" }}>
        <Typography variant="body1" color="text.secondary">
          No economy statistics available.
        </Typography>
      </Box>
    );
  }

  const StatCard = ({ title, value, color }) => (
    <Paper
      elevation={2}
      sx={{
        p: 3,
        textAlign: "center",
        borderTop: `4px solid ${color}`,
      }}
    >
      <Typography variant="h3" sx={{ fontWeight: "bold", color }}>
        {value}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
        {title}
      </Typography>
    </Paper>
  );

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Card elevation={3}>
          <CardHeader
            avatar={<AnalyticsIcon sx={{ color: indigo[500] }} />}
            title="Economy Statistics & Analytics"
            subheader="Platform economy overview and key metrics"
            sx={{ bgcolor: indigo[50] }}
          />
          <CardContent>
            <Typography variant="h6" gutterBottom sx={{ mb: 3 }}>
              Settings Overview
            </Typography>

            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} md={3}>
                <StatCard
                  title="Total Settings"
                  value={economyStatistics.total_settings || 0}
                  color={indigo[500]}
                />
              </Grid>

              {economyStatistics.by_category?.map((cat, index) => {
                const colors = [green, blue, orange, purple];
                const color = colors[index % colors.length][500];

                return (
                  <Grid item xs={12} sm={6} md={3} key={index}>
                    <StatCard
                      title={
                        cat.category?.replace(/_/g, " ").toUpperCase() ||
                        "Unknown"
                      }
                      value={cat.total_settings || 0}
                      color={color}
                    />
                  </Grid>
                );
              })}
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default AdvancedSettings;
